import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import Swal from "sweetalert2";

import { PanelService } from "../../../../../services";
import { User, Errors, PanelMember, Discussion } from "../../../../../models";

@Component({
  selector: "del-panelSeat-auth-form",
  templateUrl: "./del-panelSeat-auth-form.component.html",
  styleUrls: [
    "./del-panelSeat-auth-form.component.scss",
    "../../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class DelPanelSeatAuthForm implements OnInit {
  @Input() currentUser: User;
  @Input() discussion: Discussion;
  @Input() currentPanelMember: PanelMember;
  @Input() canModifyDiscussion: boolean;
  public errors: Errors = new Errors();
  public isSubmitting: boolean = false;
  public authForm: FormGroup;

  constructor(private panelService: PanelService, private fb: FormBuilder) {
    // use FormBuilder to create a form group
    this.authForm = this.fb.group({
      email: ["", Validators.required],
      password: ["", Validators.required],
    });
  }

  ngOnInit() {}

  public deletePanelSeat() {
    this.isSubmitting = true;
    this.errors = new Errors();
    let credentials = this.authForm.value;

    if (this.currentPanelMember || this.canModifyDiscussion) {
      this.panelService
        .deletePanelSeat(this.discussion, this.currentPanelMember, credentials)
        .subscribe(
          (data) => {
            this.fireSuccessAlert();
          },
          (err) => {
            this.errors = err;
            this.isSubmitting = false;
            this.fireErrorAlert();
          }
        );
    }
  }

  public attemptLocalAuth() {
    Swal.fire({
      title: "Delete?",
      text:
        "Are you sure you want to delete this panel seat " +
        this.currentUser.username +
        "?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Haai, cancel!",
      confirmButtonText: "Delete the panel seat!",
    }).then((result) => {
      if (result.value) {
        this.deletePanelSeat();
      }
    });
  }

  public fireSuccessAlert() {
    Swal.fire({
      title: "Deleted",
      text: "Panel seat deleted",
      type: "success",
    });
    window.location.reload();
  }

  public fireErrorAlert() {
    Swal.fire("Eish!", "There were errors with your deletion", "warning");

    function errorAlert() {
      Swal.close();
    }

    setTimeout(errorAlert, 3000);
  }
}
